import type { CSSProperties } from 'react'
import { DayPicker, getDefaultClassNames, type DayPickerProps } from 'react-day-picker'
import { fr } from 'date-fns/locale'
import 'react-day-picker/style.css'

import { cn } from '@/shared/lib/utils'

export function Calendar({ className, classNames, ...props }: DayPickerProps) {
  const base = getDefaultClassNames()
  return (
    <DayPicker
      locale={fr}
      showOutsideDays
      className={cn('p-3 text-[var(--brand-text-primary)]', className)}
      style={
        {
          '--rdp-accent-color': 'var(--brand-primary-strong)',
          '--rdp-accent-background-color': 'var(--brand-primary-soft)',
          '--rdp-range_middle-color': 'var(--brand-text-primary)',
          '--rdp-today-color': 'var(--brand-primary-strong)',
          '--rdp-day-width': '2.5rem',
          '--rdp-day-height': '2.5rem',
          '--rdp-selected-border': '0',
        } as CSSProperties
      }
      classNames={{
        ...base,
        month: cn(base.month, 'relative'),
        month_caption: cn(
          base.month_caption,
          'relative flex items-center justify-center px-10 py-1 text-sm font-semibold text-[var(--brand-text-primary)]',
        ),
        nav: cn(base.nav, 'absolute inset-x-0 top-0 flex items-center justify-between'),
        button_previous: cn(
          base.button_previous,
          'inline-flex size-11 min-h-11 min-w-11 items-center justify-center rounded-[var(--brand-radius-md)] text-[var(--brand-text-primary)]',
          'hover:bg-[var(--brand-primary-soft)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-ring)]',
        ),
        button_next: cn(
          base.button_next,
          'inline-flex size-11 min-h-11 min-w-11 items-center justify-center rounded-[var(--brand-radius-md)] text-[var(--brand-text-primary)]',
          'hover:bg-[var(--brand-primary-soft)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-ring)]',
        ),
        weekday: cn(base.weekday, 'text-xs font-medium text-[var(--brand-text-secondary)]'),
        chevron: cn(base.chevron, 'size-4 fill-[var(--brand-text-primary)]'),
        today: cn(base.today, 'font-semibold'),
        ...classNames,
      }}
      {...props}
    />
  )
}
